// deno-fmt-ignore-file
import { Number } from '../../types/number.mjs';
export function FromArray(_type) {
    return Number();
}
